import { DICT_DEFAULT_RESOURCE_TEXT } from "../utils/constants";
import SectionComponent from "./section.component";

export default class RegistrationComponent extends SectionComponent {
    
    #resourcesService;

    get #formComponent() {
        return this.querySelector("vee24-scheduler-appointment-form-section");
    }

    constructor() {
        super();
        this.formReady = false;
    }

    init(resourcesService) {
        if(!resourcesService){
            console.error("Missing Resources Service");
            return false;
        }
        this.#resourcesService = resourcesService;
        this.setInstructions(
          `<p class="v24-scheduler-customerinfo-header">${this.#resourcesService.getResource(
            "SELFSCHEDULER_CUSTOMERINFO_HEADER",
            DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_CUSTOMERINFO_HEADER
          )}</p>`
        );
        return true;
    }

    
    setupFormComponent(customerInfo) {

        this.formReady = false;

        try {

            if (customerInfo) {
                this.setContent(`<vee24-scheduler-appointment-form-error-section class="section" tabindex="-1"></vee24-scheduler-appointment-form-error-section>
                                 <vee24-scheduler-appointment-form-section></vee24-scheduler-appointment-form-section>`);
                this.#formComponent.init(this.#resourcesService);
                this.#formComponent.renderForm(JSON.parse(customerInfo));
                this.formReady = true;
            } else {
                console.error("No form structure data");
            }
            
        } catch (error) {
            console.error(error);
            this.setContent(`<div class="v24-error">${this.#resourcesService.getResource(
                "SELFSCHEDULER_FORM_LOAD_ERROR",
                DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_FORM_LOAD_ERROR
              )}</div>`);
            
        }
        
    }
}